<script setup lang="ts">
defineSlots<{ default: () => void }>();
</script>

<template>
  <header
    class="relative isolate flex h-screen min-h-220 items-center justify-center bg-[url(/images/background.webp)] bg-cover lg:min-h-148"
  >
    <slot />
  </header>
</template>
